import { Component, OnInit } from '@angular/core';
import {Title} from '@angular/platform-browser';
import {TopicService} from '../services/topic.service';
import {Topic} from '../admin/topic/model/topic';
import {ActivatedRoute, Router } from '@angular/router';
declare function escape(s:string): string;
declare function unescape(s:string): string;

@Component({
  selector: 'app-publish',
  templateUrl: './publish.component.html',
  styleUrls: ['./publish.component.css'],
})

export class PublishComponent implements OnInit {
  public hex = require("../../assets/hex.jpg");
  topics: Topic[];
  private topic = new Topic('', '', '');
  theUser: string;

  constructor(private titleService: Title, private topicService: TopicService, private activatedRoute: ActivatedRoute) 
  { }

  ngOnInit() { 
    this.theUser = "tagndoc@tagndoc.com";

    this.activatedRoute.queryParams.subscribe(params => {

      this.topic.hashTag = params['h'] || "";

      if(this.topic.hashTag != "") {
        this.titleService.setTitle(this.topic.hashTag);
        this.open(()=>{});
      }	
    });
  }

  open(callback: () => any) {
    if (this.topic.hashTag != "") {
      this.topicService.filterTopics(this.topic.hashTag, "", "", "", "tagndoc@tagndoc.com")
        .subscribe(
          topics => {
            this.topics = topics; //Bind to view
            if(this.topics !== undefined) {
              callback();
              this.topic = this.topics[0];
              var tb = document.getElementById("textBox");
              tb.innerHTML = unescape(this.topic.value);
            }
          },
          err => {
            console.log(err);
          });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/publish/publish.component.ts